import { ChangeEvent, useEffect, useState } from "react";

import { Autocomplete, SelectEvent } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";

import { InstitutionCodeBook } from "../../models";
import { useGetInstitutionListQuery, useGetInstitutionListForUserQuery } from "../../queries/codeBookQuery";

export interface InstitutionSelectProps {
  value?: number;
  name?: string;
  disabled?: boolean;
  readOnly?: boolean;
  label?: string;
  errorText?: string;
  countyId?: number;
  countyIds?: number[];
  municipalityId?: number;
  townId?: number;
  townIds?: number[];
  ids?: number[];
  onlyByEnrollmentArea?: boolean;
  excludeHandicapped?: boolean;
  excludeSatellite?: boolean;
  excludePrivate?: boolean;
  excludeIds?: number[];
  showUser?: boolean;
  allowEmpty?: boolean;

  onChange: (event: ChangeEvent<SelectEvent>) => void;
  onLoaded?: (selectedInstitution?: InstitutionCodeBook[]) => void;
}

/**
 * This is a single select component based on an AutoComplete 
 * (combobox - text + dropdown) for Institutions and may be 
 * used where an InstitutionId is optional. To change the selection, 
 * the current selection must be cleared by clicking the 'X', afterwhich 
 * a new selection may be made. Between selections, the selected value 
 * will be undefined.
 * @param param0 
 * @returns 
 */
export const InstitutionSelect = ({ 
  showUser = false, 
  value, 
  label, 
  disabled = false, 
  errorText, 
  countyId, 
  countyIds, 
  municipalityId, 
  townId, 
  townIds, 
  ids, 
  allowEmpty = false, 
  onlyByEnrollmentArea = false, 
  excludeIds, 
  onChange, 
  onLoaded,
  excludeHandicapped = false,
  excludeSatellite = false, 
  excludePrivate = false,
}: InstitutionSelectProps) => {

  const handleGetInstitutionListQuery = (showUser: boolean) =>{
    if(showUser){
      console.log('showUser: ', showUser);
      // eslint-disable-next-line react-hooks/rules-of-hooks      
      return(useGetInstitutionListForUserQuery());
    }
    else{
      console.log('showUser: ', showUser);
      // eslint-disable-next-line react-hooks/rules-of-hooks
      return(useGetInstitutionListQuery());
    }
  };

  const [institutions, setFilteredInstitutions] = useState<InstitutionCodeBook[]>();
  const { data: institutionList } = handleGetInstitutionListQuery(showUser);  

  useEffect(() => {
    (async () => {
        setFilteredInstitutions(
          institutionList
            ?.filter(x => !countyIds || countyIds.find(v => x.countyId === v) !== undefined)
            .filter(x => !countyId || x.countyId === countyId)
            .filter(x => !municipalityId || x.municipalityId === municipalityId)
            .filter(x => !townIds || townIds.find(v => x.townId === v) !== undefined)
            .filter(x => !townId || x.townId === townId)
            .filter(x => !ids || ids.find(v => x.id === v) !== undefined)
            .filter(x => !onlyByEnrollmentArea || x.isByEnrollmentArea)
            .filter(x => !excludeIds || excludeIds.find(v => x.id === v) === undefined)
            .filter(x => !excludeHandicapped || !x.isHandicapped)
            .filter(x => !excludeSatellite || !x.isSatellite)
            .filter(x => !excludePrivate || !x.isPrivate)
        );
    })();
  }, [countyId, countyIds, townId, townIds, ids, municipalityId, onlyByEnrollmentArea, excludeIds, institutionList, excludeHandicapped, excludeSatellite, excludePrivate]);
    
    // if(institutions && institutions?.length === 1 && !allowEmpty){
    //   value = institutions[0].id;      
    // }

  useEffect(() => {
    if (institutions) {
      if (onLoaded) {
        onLoaded(institutions);
      }

      // Are we forcing a value?
      if (!allowEmpty && institutions.length > 0) {
        if (institutions.length === 1 // We only have one so use it
            || value === undefined // We must set something
            || !institutions.some(v => v.id === value)) { // The desired value is not in list
          value = institutions[0].id;      
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[institutions])

 return <>
    <Autocomplete
      label={label}
      name={"InstitutionId"}
      value={value}
      disabled={disabled}
      selectData={codeBookToSelectData(institutions)}
      onChange={onChange}

      errorText={errorText}
    />
  </>
}